module.exports = __webpack_public_path__ + "static/media/english.e7a8cee7.e7a8cee7.png";